import React, { useState } from 'react';
import { SendIcon, CheckCircle2Icon } from 'lucide-react';
const eventTypes = ['Séminaire / réunion pro', 'Inauguration / lancement', 'Mariage', 'Anniversaire / fête privée', 'Fête de village / associatif', 'Autre'];
export function QuoteForm() {
  const [sent, setSent] = useState(false);
  if (sent) {
    return <div className="border-[3px] border-noir bg-jaune p-8 text-center shadow-hard" data-id="element-31" data-mp="1n5ao8lc6jx4f">
        <CheckCircle2Icon className="mx-auto h-12 w-12" aria-hidden="true" data-id="element-32" data-mp="2kqq0que3i9v9" />
        <h3 className="mt-4 font-display text-2xl uppercase leading-tight" data-id="element-33" data-mp="2ft6mvvlb7z3u">Demande reçue !</h3>
        <p className="mx-auto mt-3 max-w-md text-noir/75" data-id="element-34" data-mp="2as0r1owcrvq3">
          On revient vers vous sous 48 h ouvrées avec une proposition de menu et un devis
          détaillé. Pour une date urgente, appelez-nous au 06 00 00 00 00.
        </p>
        <button type="button" onClick={() => setSent(false)} className="mt-6 border-[3px] border-noir bg-creme px-5 py-2.5 font-display text-sm uppercase transition-transform duration-150 ease-out hover:-translate-y-0.5" data-id="element-35" data-mp="zf6par9xsljr">
          Nouvelle demande
        </button>
      </div>;
  }
  return <form onSubmit={event => {
    event.preventDefault();
    setSent(true);
  }} className="border-[3px] border-noir bg-white p-6 shadow-hard md:p-8" data-id="element-36" data-mp="30zgg8e3zz2pd">
      <div className="grid gap-5 sm:grid-cols-2" data-id="element-37" data-mp="36043qpt0p1eu">
        <Field label="Nom & prénom" name="name" required data-id="element-38" data-mp="2s64i3rqzmg8z" />
        <Field label="Structure / entreprise" name="company" placeholder="Optionnel" data-id="element-39" data-mp="2wxcrwow8c3mo" />
        <Field label="E-mail" name="email" type="email" required data-id="element-40" data-mp="2wzfoxsvsux0w" />
        <Field label="Téléphone" name="phone" type="tel" required data-id="element-41" data-mp="2ia9vymnk231g" />
        <Field label="Date de l’événement" name="date" type="date" required data-id="element-42" data-mp="2n70c19zd0ymv" />
        <Field label="Nombre de convives" name="guests" type="number" placeholder="80" required data-id="element-43" data-mp="298aejt8mowxz" />

        <label className="sm:col-span-2" data-id="element-44" data-mp="2d9dqw5rgwaug">
          <span className="text-xs font-bold uppercase tracking-[0.12em] text-noir/60" data-id="element-45" data-mp="2d8c79cwdyg14">
            Type d’événement
          </span>
          <select name="type" className="mt-1.5 w-full border-[3px] border-noir bg-creme px-3 py-2.5 font-semibold" defaultValue={eventTypes[0]} data-id="element-46" data-mp="jspxrxplboxd">
            {eventTypes.map(type => <option key={type} value={type} data-id="element-47" data-mp="52s2yyx5o0z7">
                {type}
              </option>)}
          </select>
        </label>

        <label className="sm:col-span-2" data-id="element-48" data-mp="12ozih3uzzdqc">
          <span className="text-xs font-bold uppercase tracking-[0.12em] text-noir/60" data-id="element-49" data-mp="xqxqtujia639">
            Votre projet
          </span>
          <textarea name="message" rows={4} placeholder="Lieu, horaires, contraintes (végétarien, sans porc, accès électricité…)" className="mt-1.5 w-full border-[3px] border-noir bg-creme px-3 py-2.5" data-id="element-50" data-mp="sqjsx5bmcciy" />
        </label>
      </div>

      <button type="submit" className="mt-6 inline-flex items-center gap-2 border-[3px] border-noir bg-rouge px-6 py-3 font-display text-base uppercase text-creme transition-transform duration-150 ease-out hover:-translate-y-0.5" data-id="element-51" data-mp="39fyx3sdl4jqg">
        Envoyer ma demande
        <SendIcon className="h-4 w-4" aria-hidden="true" data-id="element-52" data-mp="1xycjs77bxnqk" />
      </button>
      <p className="mt-3 text-xs text-noir/55" data-id="element-53" data-mp="1xx1eu425e9xv">
        Réponse sous 48 h ouvrées. Devis gratuit et sans engagement.
      </p>
    </form>;
}
interface FieldProps {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
}
function Field({
  label,
  name,
  type = 'text',
  placeholder,
  required
}: FieldProps) {
  return <label data-id="element-54" data-mp="2gqnhznr1gxic">
      <span className="text-xs font-bold uppercase tracking-[0.12em] text-noir/60" data-id="element-55" data-mp="2gpvkg7dvsppf">
        {label}
        {required && <span className="text-rouge" data-id="element-56" data-mp="2lmclg266iyjx"> *</span>}
      </span>
      <input type={type} name={name} placeholder={placeholder} required={required} className="mt-1.5 w-full border-[3px] border-noir bg-creme px-3 py-2.5 font-semibold placeholder:font-normal placeholder:text-noir/40" data-id="element-57" data-mp="mce71d76x984" />
    </label>;
}